<template>
	<div class="box">
		<LoadingSpinner v-if="loading" />
        <div v-else>
        	<div class="row mb-2">
        		<div class="col-auto ml-auto">
        			<b-button variant="primary" @click="askExport">{{ $t('monte.export.ask') }}<font-awesome-icon v-if="processing" :icon="['fal', 'spinner']" spin /></b-button>
        		</div>
        	</div>
        	<b-table
				striped hover
				:items="exports"
				:fields="columns"
			>
				<template v-slot:cell(download)="data">
					<a href='#' @click.prevent="downloadFile(data.item.filename)"><font-awesome-icon v-if="data.item.loading" :icon="['fal', 'spinner']" spin /><font-awesome-icon v-else :icon="['fas','download']" /></a>
				</template>
			</b-table>
        </div>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"

	export default {
		name: 'StockArchive',
		mixins: [Congelation],
		data () {
			return {
				loading: false,
				processing: false,
				exports: [],
				columns: [
					{
						key:'filename', 
						label: this.getTrad('monte.export.filename')
					},
					{
						key:'date',
						label: this.getTrad('monte.export.date')
					},
					{
						key:'download',
						label: this.getTrad('monte.export.download')
					}
				],
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.loading = true
                const res = await this.getAllStockExport()
                this.exports = res.map(e => ({...e, date: this.formatDate(e.date), loading: false}))
                this.loading = false
			},

			async downloadFile(filename) {
				const index = this.exports.findIndex(e => e.filename == filename)
				this.exports[index].loading = true
                await this.downloadStockExport(filename)
				this.exports[index].loading = false
			},

			async askExport() {
				this.processing = true
                await this.askStockExport()
                this.successToast('monte.export.asked')
				this.processing = false
			}
		},

		components: {
			LoadingSpinner : () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		}
	}

</script>